<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :show-date="customFilters.dispatchTime ? false : true"
      date-option-type="datetime"
      :date-validation="true"
      :product-options="productOptions"
      search-label="search"
      vertical-scroll
      :filter-names="filterNames"
      @filterOption="onFiltersChange"
    >
      <template v-slot:nozzle_number="{ item }">
        <div class="">
          {{ item.display_name || item.nozzle_number }}
        </div>
      </template>
      <template v-slot:date_time="{ item }">
        <div>
          {{ item.date_time | formatDate }}
        </div>
      </template>
      <template v-slot:entity_type="{ item }">
        <div class="text-capitalize">
          {{ item.entity_type }}
        </div>
      </template>

      <template #addFilters>
        <v-card>
          <v-select
            v-model="customFilters.terminal_id"
            filled
            dense
            clearable
            :items="terminalList"
            item-value="id"
            item-text="name"
            :label="$t('terminal')"
            @change="onTerminalChange"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.dispenser_id"
            filled
            dense
            clearable
            :items="dispenserList"
            item-value="id"
            item-text="dispenser_identifier"
            :label="$t('dispenser')"
            @change="onDispenserChange"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="customFilters.nozzle_id"
            filled
            dense
            clearable
            :items="nozzleList"
            item-value="id"
            :item-text="(n) => n.display_name || n.nozzle_number"
            :label="$t('nozzle_number')"
            @change="fetchData"
          />
        </v-card>
        <DateFilter
          v-if="[128].includes(options.tenant_id)"
          v-model="customFilters.dispatchTime"
          dense
          label="dispatch_time"
          :default-selected="''"
          :validate-date-limit="true"
          :custom="true"
          :date-option-type="'datetime'"
          :date-disabled="false"
          @change="onDateChange"
          @key="onDateKeyChange"
        />
        <!-- :date-type="customFilters.dispatchTimeKey" -->
        <!-- :date-range="customFilters.dispatchTime" -->
      </template>

      <!-- Desc -->
      <template v-slot:description>
        <section v-if="list.length > 0 && customFilters.terminal_id">
          <div class="fuel-cards">
            <dashboard-cards
              :is-loading="isLoading"
              :items="dashboardTags"
            />
          </div>
        </section>
      </template>
      <!-- Desc -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { debounce } from "lodash";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    dashboardCards: () =>
      import("@/components/sections/DashboardSliderCards.vue"),
    DateFilter: () => import("@/components/base/DateDropDown.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      locationModal: false,
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "fleet", value: "Fleet" },
        { id: "dispenser", value: "Dispenser" },
      ],
      operational_status: null,
      isMounted: false,
      filters: {},
      subFilters: {},
      //
      customFilters: {},
      nozzleList: [],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "fuelTanks/getSessionLoading",
      meta: "fuelTanks/getSessionMeta",
      list: "fuelTanks/getSessionList",
      terminalList: "terminal/getTerminalDropDown",
      dispenserList: "fuelDispenser/getList",
      //
      dashboardData: "fuelDispenserDashboard/getList",
    }),
    filterNames() {
      return [];
    },
    cardsData() {
      return this.dashboardData?.aggregated_data
        ? this.dashboardData?.aggregated_data[0]
        : [];
    },
    dashboardTags() {
      const arrData = this.cardsData;
      return [
        {
          myIcon: "total-filling-cost",
          name: "total_fuel_cost",
          value: arrData?.total_fuel_cost,
          unit: this.$options.filters.currencyFormat(
            this.$t("units.fuel_cost"),
            this.authUser
          ),
        },
        {
          // myIcon: "destination-icon",
          myIcon: "total-fillings-volume",
          name: "total_volume_out",
          value: arrData?.total_volumn_out,
          unit: "(L)",
        },
        {
          myIcon: "total-filling-count",
          name: "total_filling",
          value: arrData?.total_filling_count,
          unit: "(Count)",
        },
      ];
    },
    _headers() {
      const headers = [
        {
          text: this.$t("session_id"),
          align: "left",
          sortable: true,
          value: "session_id",
        },
        {
          text: this.$t("dispenser_identifier"),
          sortable: true,
          value: "dispenser_identifier_cid",
        },
        {
          text: this.$t("imei"),
          align: "left",
          sortable: true,
          value: "imei",
        },
        {
          text: this.$t("date_time"),
          align: "left",
          sortable: true,
          value: "date_time",
        },
        {
          text: this.$t("vehicle_id"),
          align: "left",
          sortable: true,
          value: "vehicle_tag",
        },
        {
          text: this.$t("nozzle_number"),
          align: "center",
          sortable: true,
          value: "nozzle_number",
        },
        {
          text: this.$options.filters.currencyFormat(
            this.$t("fuel_cost"),
            this.authUser
          ),
          align: "center",
          sortable: true,
          value: "fuel_cost",
        },
        {
          text: this.$t("durationMin"),
          align: "center",
          sortable: true,
          value: "duration",
        },
        {
          text: this.$t("quantity"),
          align: "center",
          sortable: true,
          value: "qty",
        },
        {
          text: this.$t("last_dispatch_time"),
          align: "center",
          sortable: true,
          value: "dispatch_time_gmt_05",
        },
      ];
      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (v) {
        if (v) {
          const params = { tenant_id: v };
          this.$store.dispatch("terminal/dropDownList", params);
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
        }
      },
    },
    "options.fleetId": {
      handler: function (v) {
        if (v) {
          const params = { tenant_id: v };
          this.$store.dispatch("terminal/dropDownList", params);
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
        }
      },
    },
    options() {
      this.fetchData();
    },
  },
  async mounted() {
    this.$store.dispatch("fuelTanks/setSessionLoadingValue", true);
    if (!this.authUser.isAdmin) {
      const tId = this.authUser?.independent_fleet_user_nature
        ? this.authUser.tenant_id
        : this.authUser.parent_tenant_id;
      const params = { tenant_id: tId };
      await this.$store.dispatch("terminal/dropDownList", params);
    }

    // setTimeout(() => {
    if (this.$route?.query?.terminal_id) {
      this.customFilters.terminal_id = parseInt(this.$route.query.terminal_id);
      await this.onTerminalChange(this.customFilters.terminal_id);
    }
    if (this.$route?.query?.dispenser_id) {
      this.customFilters.dispenser_id = parseInt(
        this.$route.query.dispenser_id
      );
      await this.onDispenserChange(this.customFilters.dispenser_id);
    }
    if (this.$route?.query?.nozzle_id) {
      this.customFilters.nozzle_id = parseInt(this.$route.query.nozzle_id);
    }
    // this.fetchData();
    // }, 1500);
  },

  beforeDestroy() {
    const paramsset = { ...this.options, ...this.customFilters };
    const params = {
      name: "vehicle_fuel_sessions",
      filters: paramsset,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    getNozzleName(item) {
      return item.display_name || item.nozzle_number;
    },
    fetchData: debounce(async function () {
      const params = { ...this.options, ...this.customFilters };
      //
      if (this.customFilters.dispatchTime) {
        delete params.date;
        delete params.dateType;
      } else {
        delete params.dispatchTime;
        delete params.dispatchTimeKey;
      }
      //
      await this.$store.dispatch("fuelTanks/sessionsList", params).then(() => {
        this.cardData();
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    }, 1500),

    cardData: debounce(async function () {
      if (this.customFilters.terminal_id) {
        //  // Cancel any ongoing requests in the same group
        // this.cancelRequestGroup();

        // // Track the new request
        // const controller = this.trackRequest();

        const params = {
          ...this.options,
          ...this.customFilters,
          // signal: controller.signal,
        };
        if (this.customFilters.dispatchTime) {
          delete params.date;
          delete params.dateType;
        } else {
          delete params.dispatchTime;
          delete params.dispatchTimeKey;
        }

        await this.$store
          .dispatch("fuelDispenserDashboard/list", params)
          .then(() => {
            if (this.options.page > (this.meta?.lastPage || 1)) {
              this.options.page = 1;
            }
          });
      } else {
        this.$store.commit("fuelDispenserDashboard/SET_LIST", []);
      }
    }, 800),
    //
    async onTerminalChange(v) {
      delete this.customFilters.dispenser_id;
      delete this.customFilters.nozzle_id;
      if (v) {
        const params = { terminal_id: v };
        await this.$store.dispatch("fuelDispenser/list", params);
      } else {
        this.$store.commit("fuelDispenser/SET_LIST", []);
      }
      this.fetchData();
    },
    async onDispenserChange(v) {
      delete this.customFilters.nozzle_id;
      if (v) {
        const dRow = this.dispenserList.find((r) => r.id === v);
        this.nozzleList = dRow?.nozzles;
        // await this.$store.dispatch(
        //   "dataLogs/busNoDropdown",
        //   this.customFilters
        // );
      } else {
        // this.$store.commit("dataLogs/SET_BUS_LIST", []);
        this.nozzleList = [];
      }
      this.fetchData(v);
    },

    onDateChange(v) {
      this.customFilters.dispatchTime = v;
      this.fetchData();
    },
    onDateKeyChange(v) {
      // this.dataTypeValue = true;
      this.customFilters.dispatchTimeKey = v;
    },
    //
  },
};
</script>
<style lang="sass" scoped>
.map-button
  height: 41px !important
  margin-right: 5px

.btn-disabled
  pointer-events: none !important
  background-color: #8f8f8f !important

:deep .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined).v-input--dense .v-select__slot > input
  font-size: 0.875rem !important


:deep .fuel-cards .sectionOneBoxWrap .insideItemBoxWrap .itemBoxes .iconBox span .lg
  width: 2.3rem
:deep .fuel-cards .sectionOneBoxWrap .insideItemBoxWrap .itemBoxes .iconBox span .total-filling-cost
  width: 4.3rem
</style>
